export default "__VITE_ASSET__M2c_20hS__"